"use strict";
"use restrict";

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

module.exports = UnionFind;

function UnionFind(count) {
  this.roots = new Array(count);
  this.ranks = new Array(count);

  for (var i = 0; i < count; ++i) {
    this.roots[i] = i;
    this.ranks[i] = 0;
  }
}

var proto = UnionFind.prototype;
Object.defineProperty(proto, "length", {
  "get": function get() {
    return this.roots.length;
  }
});

proto.makeSet = function () {
  var n = this.roots.length;
  this.roots.push(n);
  this.ranks.push(0);
  return n;
};

proto.find = function (x) {
  var x0 = x;
  var roots = this.roots;

  while (roots[x] !== x) {
    x = roots[x];
  }

  while (roots[x0] !== x) {
    var y = roots[x0];
    roots[x0] = x;
    x0 = y;
  }

  return x;
};

proto.link = function (x, y) {
  var xr = this.find(x),
      yr = this.find(y);

  if (xr === yr) {
    return;
  }

  var ranks = this.ranks,
      roots = this.roots,
      xd = ranks[xr],
      yd = ranks[yr];

  if (xd < yd) {
    roots[xr] = yr;
  } else if (yd < xd) {
    roots[yr] = xr;
  } else {
    roots[yr] = xr;
    ++ranks[xr];
  }
};

;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(UnionFind, "UnionFind", "/home/yatham/Dev_BHS_Portal/node_modules/union-find/index.js");
  reactHotLoader.register(proto, "proto", "/home/yatham/Dev_BHS_Portal/node_modules/union-find/index.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();